module.exports = __webpack_public_path__ + "img/image3@2x.82cfeec7.png";